import getLogger from '@ignitesales/logger-es';
import ignite from '../../services';
import {SALESFORCE_ACCOUNT_ID_APPKEY} from '../../utils/constants.mjs';

const logger = getLogger({ module: 'integration-action-creators' });

const IntegrationActions = {
  SALESFORCE_SUBMIT_STARTED: 'SALESFORCE_SUBMIT_STARTED',
  SALESFORCE_SUBMIT_COMPLETED: 'SALESFORCE_SUBMIT_COMPLETED',
  SALESFORCE_REQUEST_FAILED: 'SALESFORCE_REQUEST_FAILED'
};

const sendToSalesforce = () => {
  return async (dispatch, getState) => {
    dispatch( processActionType(IntegrationActions.SALESFORCE_SUBMIT_STARTED) );
    try {
      const {
        user: { uuid },
        guideConfigurations: { salesforceConfig }
      } = getState();
      const sfAccountIdAnswer = await ignite.answerService.getAnswer(SALESFORCE_ACCOUNT_ID_APPKEY);
      let resultActionType = null;

      if( salesforceConfig && salesforceConfig?.clientEndpoint && sfAccountIdAnswer && sfAccountIdAnswer.value ) {
        // force https here instead of using location.protocol to prevent sending info over http
        const response = await fetch( 'https://' + location.host + '/' + salesforceConfig.clientEndpoint, {
          headers: { 'Content-Type': 'text/xml' },
          method: 'POST',
          mode: 'cors',
          body: await _formatPayloadBody(uuid)
        } );
        resultActionType = response.ok ? IntegrationActions.SALESFORCE_SUBMIT_COMPLETED : IntegrationActions.SALESFORCE_REQUEST_FAILED;
      } else {
        logger.warn('Unable to send to Salesforce due to incomplete configurations', { salesforceConfig, sfAccountIdAnswer });
        dispatch( processActionType(IntegrationActions.SALESFORCE_REQUEST_FAILED) );
      }

      dispatch( processActionType(resultActionType) );
    } catch (ex) {
      logger.error('An error while loading locations', ex);
      dispatch( processActionType(IntegrationActions.SALESFORCE_REQUEST_FAILED) );
    }
  };
};

const _formatPayloadBody = async (uuid) => {
  let content = `<lead><uuid>${uuid}</uuid>`;
  const notes = await ignite.noteService.retrieveNotes();

  console.log('note list', notes);
  for (const note of notes) {
    const noteValue = String(note.content).replace(/[^A-z0-9\s]+/g, '');
    content += `<note>
        <content>${noteValue}</content>
        <timestamp>${note.timestamp}</timestamp>
        <employee>${note.employee}</employee>
    </note>`;
  }
  content += '</lead>';
  return content;
};

const processActionType = (type) => {
  return { type };
};

export {
  IntegrationActions,
  sendToSalesforce
};
